module.exports = __webpack_public_path__ + "static/media/hyperx-cloud-alpha.e6e9e389.jpg";